import React, { Component } from "react";

import { connect } from "react-redux";

import { updateExternalBrakeRelease } from "../actions/";

 

class ExternalBrakeRelease extends Component {

  constructor(props) {

    super(props);

    this.state = {

      externalBrakeRelease: [

        {

          value: "without emergency brake release",

          orderCode: "0",

          weight: 0

        },

        {

          value: "with emergency brake release",

          orderCode: "1",

          weight: 0

        }

      ]

    };

    this.handleOnchange = this.handleOnchange.bind(this);

  }

 

  handleOnchange = selected => {

    this.props.onExternalBrakeReleaseSelect(JSON.parse(selected.target.value));

  };

 

  componentDidUpdate(prevProps) {

    if (prevProps.winchType.orderCode !== this.props.winchType.orderCode) {

      var ele = document.getElementsByName("externalBrakeRelease");

      for (var i = 0; i < ele.length; i++) ele[i].checked = false;

      ele[0].checked = true;

      this.props.onExternalBrakeReleaseSelect({

        value: "without emergency brake release",

        orderCode: "0",

        weight: 0

      });

    }

    if (

      prevProps.winchType !== this.props.winchType ||

      prevProps.mType !== this.props.mType ||

      this.props.previewStatus !== prevProps.previewStatus

    ) {

      if (

        this.props.mType === "metric" &&

        this.props.winchType.orderCode === "01"

      ) {

        this.setState({

          externalBrakeRelease: [

            {

              value: "without emergency brake release",

              orderCode: "0",

              weight: 0

            },

            {

              value: "with emergency brake release",

              orderCode: "1",

              weight: 0.3

            }

          ]

        });

      } else if (

        this.props.mType === "imperial" &&

        this.props.winchType.orderCode === "01"

      ) {

        this.setState({

          externalBrakeRelease: [

            {

              value: "without emergency brake release",

              orderCode: "0",

              weight: 0

            },

            {

              value: "with emergency brake release",

              orderCode: "1",

              weight: 0.7

            }

          ]

        });

      } else if (

        this.props.mType === "metric" &&

        this.props.winchType.orderCode === "02"

      ) {

        this.setState({

          externalBrakeRelease: [

            {

              value: "without emergency brake release",

              orderCode: "0",

              weight: 0

            },

            {

              value: "with emergency brake release",

              orderCode: "1",

              weight: 0.35

            }

          ]

        });

      } else if (

        this.props.mType === "imperial" &&

        this.props.winchType.orderCode === "02"

      ) {

        this.setState({

          externalBrakeRelease: [

            {

              value: "without emergency brake release",

              orderCode: "0",

              weight: 0

            },

            {

              value: "with emergency brake release",

              orderCode: "1",

              weight: 0.8

            }

          ]

        });

      } else if (

        this.props.mType === "metric" &&

        this.props.winchType.orderCode === "04"

      ) {

        this.setState({

          externalBrakeRelease: [

            {

              value: "without emergency brake release",

              orderCode: "0",

              weight: 0

            },

            {

              value: "with emergency brake release",

              orderCode: "1",

              weight: 0.5

            }

          ]

        });

      } else if (

        this.props.mType === "imperial" &&

        this.props.winchType.orderCode === "04"

      ) {

        this.setState({

          externalBrakeRelease: [

            {

              value: "without emergency brake release",

              orderCode: "0",

              weight: 0

            },

            {

              value: "with emergency brake release",

              orderCode: "1",

              weight: 1.1

            }

          ]

        });

      } else if (

        this.props.mType === "metric" &&

        this.props.winchType.orderCode === "05"

      ) {

        this.setState({

          externalBrakeRelease: [

            {

              value: "without emergency brake release",

              orderCode: "0",

              weight: 0

            },

            {

              value: "with emergency brake release",

              orderCode: "1",

              weight: 0.5

            }

          ]

        });

      } else if (

        this.props.mType === "imperial" &&

        this.props.winchType.orderCode === "05"

      ) {

        this.setState({

          externalBrakeRelease: [

            {

              value: "without emergency brake release",

              orderCode: "0",

              weight: 0

            },

            {

              value: "with emergency brake release",

              orderCode: "1",

              weight: 1.1

            }

          ]

        });

      }

    }

  }

 

  componentDidMount() {

    if (this.props.previewStatus !== "show") {

      this.props.onExternalBrakeReleaseSelect({

        value: "without emergency brake release",

        orderCode: "0",

        weight: 0

      });

    }

  }

 

  render() {

    var externalBrakeRelease = this.state.externalBrakeRelease.map(

      (ebr, index) => {

        return (

          <div className="col-md-6" key={index}>

            <label className="ebr-container">

              <input

                type="radio"

                value={JSON.stringify(ebr)}

                name="externalBrakeRelease"

                defaultChecked={

                  this.props.externalBrakeRelease.orderCode

                    ? this.props.externalBrakeRelease.orderCode ===

                      ebr.orderCode

                    : index === 0

                }

              />{" "}

              {ebr.value}

              <span className="checkmark" />

            </label>

          </div>

        );

      }

    );

    return (

      <div>

        <div className="field-top">Emergency brake release</div>

        <div className="selection-body">

          <p>

            This option allows releasing the brake and lowering the load with an

            auxiliary hydraulic supply. In case of failure of the main hydraulic

            system the operator can easily unload the winch to secure the system

            and to prevent bigger damages.

          </p>

          <div className="row" onChange={this.handleOnchange}>

            {externalBrakeRelease}

          </div>

          <br />

        </div>

      </div>

    );

  }

}

 

const mapStateToProps = state => {

  return {

    mType: state.mType,

    winchType: state.winchType,

    externalBrakeRelease: state.externalBrakeRelease,

    previewStatus: state.previewStatus

  };

};

 

const mapActionsToProps = {

  onExternalBrakeReleaseSelect: updateExternalBrakeRelease

};

 

export default connect(

  mapStateToProps,

  mapActionsToProps

)(ExternalBrakeRelease);

 



// WEBPACK FOOTER //
// ./src/components/externalBrakeRelease.js